module.exports = __webpack_public_path__ + "3e1803ca5842b523a8cb95086360d5a6.jpg";